export default __webpack_public_path__ + "static/media/monitor.055639b7.png";